import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import PageLayout from '../../components/PageLayout';
import SelectBase from '../../components/SelectBase';
import analytics from '../../lib/analytics';
import useCountries from '../../lib/hooks/useCountries';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { currentlyEmployedSelector } from '../../reducers/selectors';

const EmployerCountryPage = ({
  initialEmployerCountry,
  currentlyEmployed,
  dispatchAddPageData,
  dispatchWizardNav,
}) => {
  const [country, setCountry] = useState(initialEmployerCountry);
  const { data: countries } = useCountries();

  const titleText = () =>
    currentlyEmployed ? 'What country is your office in?' : 'What country was your office in?';

  const isInvalid = country === null;

  const handleSubmit = event => {
    event.preventDefault();

    if (isInvalid) {
      return;
    }

    analytics.sendEvent('Click - Next', 'employer-country');

    const { value: employerCountryCode } = country;
    const payload = payloadFactory.createAddPageDataPayload(
      'employerCountry',
      country,
      'employerOfficeCountryCode',
      employerCountryCode,
    );
    dispatchAddPageData(payload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  return (
    <PageLayout title={titleText()}>
      <form onSubmit={handleSubmit}>
        <div className="row row--align-middle">
          <div className="col col--12/16-small">
            <SelectBase
              value={country}
              onChange={data => setCountry(data)}
              options={countries}
              placeholder="Search country"
              noOptionsMessage="We couldn't find that country."
            />
          </div>
        </div>
        <div className="row">
          <div className="col col--auto">
            <Button type="submit" isDisabled={isInvalid}>
              Next
            </Button>
          </div>
        </div>
      </form>
    </PageLayout>
  );
};

EmployerCountryPage.propTypes = {
  initialEmployerCountry: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  currentlyEmployed: PropTypes.bool.isRequired,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

EmployerCountryPage.defaultProps = {
  initialEmployerCountry: null,
};

const mapStateToProps = state => ({
  initialEmployerCountry: state.builder.ui.employerCountry,
  currentlyEmployed: currentlyEmployedSelector(state),
});

const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { EmployerCountryPage, mapStateToProps, mapDispatchToProps };

export default connect(mapStateToProps, mapDispatchToProps)(EmployerCountryPage);
